import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import VueAnalytics from "vue-analytics";
import {VueReCaptcha} from 'vue-recaptcha-v3'

Vue.config.productionTip = false

Vue.prototype.$http = require('axios');

Vue.use(VueAnalytics, {
    id: 'UA-145832069-2',
    router
})

Vue.use(VueReCaptcha, {
    siteKey: '6LezPxoaAAAAAKpePTzwIO_mZVJfMUx87mfCEo_W',
    loaderOptions: {useRecaptchaNet: true, explicitRenderParameters: {badge: 'bottomleft'}}
});

new Vue({
    vuetify,
    router,
    render: h => h(App),
}).$mount('#app')
